import { createSelector } from 'reselect';
import { MOET_CONSTANTS } from 'moet-core';
import { selectors as i18nSelectors } from 'mage-i18n';

import { getMappedCountryConfig } from './common';
import { getMerchantPayoutStatus } from './status';

const { STEP_STATUS } = MOET_CONSTANTS;

export const getCountrySupportPhone = createSelector(
  getMappedCountryConfig,
  getMerchantPayoutStatus,
  ({ MOS_SUPPORT_PHONE, SUPPORT_PHONE }, merchantPayoutStatus) =>
    merchantPayoutStatus === STEP_STATUS.DONE ? SUPPORT_PHONE : MOS_SUPPORT_PHONE || SUPPORT_PHONE,
);

export const getCountryMosEmail = createSelector(
  getMappedCountryConfig,
  i18nSelectors.language,
  ({ SUPPORT_EMAIL }, language) => {
    if (typeof SUPPORT_EMAIL === 'string') {
      return SUPPORT_EMAIL;
    }

    return SUPPORT_EMAIL?.[language] || SUPPORT_EMAIL?.default;
  },
);

export const getKlarnaDotComProductsLink = createSelector(
  getMappedCountryConfig,
  ({ KLARNA_COM_PRODUCTS_LINK }) => KLARNA_COM_PRODUCTS_LINK,
);

export const getKlarnaDotComSupportLink = createSelector(
  getMappedCountryConfig,
  ({ KLARNA_COM_SUPPORT_LINK }) => KLARNA_COM_SUPPORT_LINK,
);
